/** Sound on/off as a switch (persisted; default on). */
import clsx from 'clsx';
import { sfx } from '../audio/sfx';
import { useUiStore } from '../state/uiStore';
import { IconMute, IconSound } from './Icons';
import { Tooltip } from './Tooltip';
import './Settings.css';

export function SoundToggle({ showLabel = false }: { showLabel?: boolean }) {
  const sound = useUiStore((s) => s.sound);
  const setSound = useUiStore((s) => s.setSound);

  const toggle = () => {
    setSound(!sound);
    // A soft click confirms that sound is now on (the audio engine is enabled synchronously).
    if (!sound) sfx.pick();
  };

  const button = (
    <button
      type="button"
      role="switch"
      aria-checked={sound}
      aria-label={showLabel ? undefined : 'Sound'}
      className={clsx('sound-toggle', showLabel && 'sound-toggle--labelled')}
      onClick={toggle}
    >
      <span className="sound-toggle__icon" aria-hidden="true">
        {sound ? <IconSound /> : <IconMute />}
      </span>
      {showLabel && (
        <>
          <span className="sound-toggle__label">Sound</span>
          <span className="switch" aria-hidden="true">
            <span className="switch__thumb" />
          </span>
        </>
      )}
    </button>
  );

  return showLabel ? button : <Tooltip content={sound ? 'Sound is on' : 'Sound is off'}>{button}</Tooltip>;
}
